import Service from "../service";
const url = 'search'
const search = {
    get(keyword) {
        return Service.get(url, {
            params: { search: keyword }
        });
    },
}
export default search